import { render, staticRenderFns } from "./CustomQuestions.vue?vue&type=template&id=c11b038e&scoped=true"
import script from "./CustomQuestions.vue?vue&type=script&lang=js"
export * from "./CustomQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11b038e",
  null
  
)

export default component.exports